import { invalidSlugErrorMessage } from '_/utils/validation/slugValidator';
import { Typography } from 'antd';
import React, { ReactElement } from 'react';

function SlugField(): ReactElement {
  return (
    <Typography.Text type="danger" style={{ display: 'block', margin: '2px 0' }}>
      {invalidSlugErrorMessage}
    </Typography.Text>
  );
}

export default SlugField;
